import { useEffect, useState } from 'react'

const OrganizationLogo = ({ slug, styles = null, onCheck = null }) => {
  const [organizationLogo, setOrganizationLogo] = useState(null)

  // Uploaded logos live under a stable, extensionless key — the content type
  // travels with the object, which is what lets the same URL serve a PNG or an
  // SVG. cdnURL is unset in dev, where the same path is served locally from
  // disk by the dev-only handler in server/app.js.
  const orgLogosPath = `${CONFIG.cdnURL || ''}/usercontent/orglogos`

  const checkImageExists = () => {
    if (!slug) return setOrganizationLogo(null)

    const imageUrl = `${orgLogosPath}/${slug}`

    if (organizationLogo === imageUrl) return // Skip if already loaded

    const image = new Image()
    image.src = imageUrl

    image.onerror = () => {
      setOrganizationLogo(null)

      if (onCheck) {
        onCheck(null)
      }
    }

    image.onload = () => {
      setOrganizationLogo(imageUrl)
      if (onCheck) {
        onCheck(imageUrl)
      }
    }
  }

  useEffect(() => {
    checkImageExists()
  }, [slug])

  return (
    <>{organizationLogo && <img src={organizationLogo} alt={`Organization logo of ${slug}`} className={styles} />}</>
  )
}

export default OrganizationLogo
